import { useEffect, useState, React } from "react";
import {
  Button,
  Drawer,
  Form,
  Space,
  Table,
  Col,
  Row,
  Input,
  Divider,
  Tag,
  Tooltip,
  Radio,
} from "antd";
import {
  FilterOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  CloseOutlined,
  KeyOutlined,
} from "@ant-design/icons";
import ConfigPadraoValorRequest from "./ConfigPadraoValorRequest";
import CadastroConfigPadraoValor from "./CadastroConfigPadraoValor";
import SelConfigPadrao from "../../Selecao/ConfigPadrao/Sel_ConfigPadrao";
import { ModalDelete } from "./modais/modalDelete";
import { colors } from "../../Utils/temas";
const { Group } = Radio;

const ConfigPadraoValor = () => {
  const [filtros, setFiltros] = useState([]);
  const [configPadraoValor, setConfigPadraoValor] = useState([]);

  const [loading, setLoading] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalConfigPadraoVisible, setIsModalConfigPadraoVisible] =
    useState(false);

  const [form_pesquisa] = Form.useForm();

  const [totalRecords, setTotalRecords] = useState(0);
  const [ConfigPadraoValorId, setConfigPadraoValorId] = useState(null);
  const [idDelete, setIdDelete] = useState(null);

  async function FetchRecords(page, pageSize, params) {
    setLoading(true);
    const response = await ConfigPadraoValorRequest.getListaConfigPadraoValor(
      page,
      pageSize,
      params
    );
    if (response.status === 200) {
      setConfigPadraoValor(response.data.results);
      setTotalRecords(response.data.count);
      setLoading(false);
    }
  }

  const { Search } = Input;

  async function onPesquisarClick(value) {
    setFiltros(value);
    FetchRecords(1, 10, value);
    setDrawerVisible(false);
  }

  const Limpar = () => {
    setFiltros([]);
    form_pesquisa.resetFields();
    FetchRecords(1, 10, {});
    setDrawerVisible(false);
  };

  const OnCancel = () => {
    setIsModalVisible(false);
    setConfigPadraoValorId(null);
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  function onInserirClick() {
    showModal();
  }

  async function onEditConfigPadraoValor(id) {
    setConfigPadraoValorId(id);
    showModal(true);
  }

  function onDeletarConfigPadraoValor(id) {
    setOpenDelete(true);
    setIdDelete(id);
  }

  useEffect(() => {
    FetchRecords(1, 10, {});
  }, []);

  const columns = [
    { title: "Usuário", dataIndex: "usuario_nome" },
    {
      title: "Data Alteração",
      dataIndex: "data_alteracao",
      render: (value) => {
        const date = new Date(value);
        const dateFormatted = date.toLocaleString().replace(",", "");
        return dateFormatted;
      },
    },
    {
      title: "Descrição",
      dataIndex: "descricao",
    },
    {
      title: "Valor",
      dataIndex: "valor",
    },
    {
      title: "Config Padrão",
      dataIndex: "config_padrao_descricao",
    },
    {
      title: "Ticket",
      dataIndex: "ticket",
    },
    {
      title: "Em teste",
      dataIndex: "em_teste",
      render: (valor) => {
        const tagFormat = () => {
          if (valor) {
            return "Sim";
          }
          return "Não";
        };

        return <Tag color={valor ? "green" : "red"}>{tagFormat()}</Tag>;
      },
    },
    {
      title: "Ações",
      key: "acoes",
      render: (record) => (
        <Space>
          <Tooltip title="Editar">
            <EditOutlined onClick={(_) => onEditConfigPadraoValor(record.id)} />
          </Tooltip>

          <Tooltip title="Deletar">
            <DeleteOutlined
              onClick={(_) => onDeletarConfigPadraoValor(record.id)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const buscarConfigPadraoId = () => {
    setIsModalConfigPadraoVisible(true);
  };

  function onSelecionarConfigPadrao(valor) {
    setIsModalConfigPadraoVisible(false);
    form_pesquisa.setFieldsValue({
      config_padrao_id: valor.id,
      config_padrao_descricao: valor.descricao,
    });
  }

  const tags = {
    descricao: "Descrição",
    config_padrao_descricao: "Config Padrão",
    config_padrao_id: "Config Padrão Id",
    ticket: "Ticket",
    em_teste: "Em teste",
  };

  const onRemoverFiltros = (key) => {
    const novosFiltros = { ...filtros };
    delete novosFiltros[key];

    setFiltros(novosFiltros);
    FetchRecords(1, 10, novosFiltros);
  };

  const getTags = () => (
    <>
      {Object.entries(filtros)
        .filter(([key, value]) => value !== undefined)
        .map(([key, value]) => {
          const tagColors = () => {
            if (key === "descricao") {
              return "geekblue";
            } else if (key === "em_teste" && value) {
              return "green";
            } else if (key === "config_padrao_descricao") {
              return "cyan";
            }
            return "red";
          };

          if (value === "") return undefined;

          return (
            <Tag
              closable
              onClose={() => onRemoverFiltros(key)}
              key={key}
              color={tagColors(key)}
            >
              {tags[key] +
                ": " +
                (key === "em_teste" ? (value ? "Sim" : "Não") : value)}
            </Tag>
          );
        })}
    </>
  );

  return (
    <div>
      <div
        style={{ display: "flex", justifyContent: "space-between", padding: 5 }}
      >
        <Button
          onClick={onInserirClick}
          style={{
            background: colors.secondary,
            fontWeight: "500",
            color: "white",
          }}
          className="botao"
        >
          <PlusOutlined />
          Inserir
        </Button>

        <Button
          onClick={() =>
            setDrawerVisible((prevDrawerVisible) => !prevDrawerVisible)
          }
          style={{
            background: colors.secondary,
            fontWeight: "500",
            color: "white",
          }}
          className="botao"
        >
          <FilterOutlined />
          Filtros
        </Button>
        <Drawer
          width={400}
          visible={drawerVisible}
          onClose={() => setDrawerVisible(false)}
        >
          <Form
            form={form_pesquisa}
            layout="vertical"
            onFinish={onPesquisarClick}
            preserve={true}
          >
            <Row gutter={10}>
              <Col span={24}>
                <Form.Item name="descricao" label="Descrição">
                  <Input />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item name="config_padrao_descricao" label="Config padrão">
              <Search readOnly allowClear onSearch={buscarConfigPadraoId} />
            </Form.Item>

            <Form.Item name="ticket" label="Ticket">
              <Input />
            </Form.Item>

            <Form.Item
              name="em_teste"
              label="Em teste:"
              style={{ fontWeight: "500" }}
            >
              <Group>
                <Radio value={true}>Sim</Radio>
                <Radio value={false}>Não</Radio>
              </Group>
            </Form.Item>

            <Divider style={{ background: "#DCDCDC" }} />

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                htmlType="submit"
                style={{
                  background: colors.secondary,
                  fontWeight: "500",
                  color: "white",
                }}
                className="botao"
              >
                <KeyOutlined />
                Pesquisar
              </Button>

              <Button onClick={Limpar}>
                <CloseOutlined />
                Limpar
              </Button>
            </div>
          </Form>
          <SelConfigPadrao
            onSelecionado={(valor) => {
              onSelecionarConfigPadrao(valor);
            }}
            visible={isModalConfigPadraoVisible}
            onCancel={() => setIsModalConfigPadraoVisible(false)}
          />
        </Drawer>
      </div>
      <Table
        loading={loading}
        columns={columns}
        rowKey={"id"}
        dataSource={configPadraoValor}
        pagination={{
          total: totalRecords,
          showTotal: (total) => (
            <span
              style={{ fontWeight: "500", position: "absolute", left: "4%" }}
            >
              Quantidade: {total}
            </span>
          ),
          onChange: (page, pagaSize) => {
            FetchRecords(page, pagaSize, filtros);
          },
        }}
        title={getTags}
        scroll={{ x: true }}
      />
      <CadastroConfigPadraoValor
        visible={isModalVisible}
        onCancel={OnCancel}
        estadoPadraoValor={setConfigPadraoValor}
        id={ConfigPadraoValorId}
      />

      <ModalDelete
        visible={openDelete}
        onCancel={() => {
          setOpenDelete(false);
          setConfigPadraoValorId(null);
        }}
        estadoConfig={setConfigPadraoValor}
        id={idDelete}
      />
    </div>
  );
};

export default ConfigPadraoValor;
